<div class="main-content-layout">
  <router-outlet />
</div>
<app-thermal-receipt></app-thermal-receipt>
